export default __webpack_public_path__ + "static/media/chamath3x.182639df.png";